"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scoreLevel = exports.reportNavList = exports.excludeReportNavList = void 0;

require("core-js/modules/es.object.to-string.js");

var _interopRequireWildcard2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));

var reportNavList = [{
  meta: {
    title: '性能总览',
    'pageKey': 'p_summary'
  },
  name: 'ReportGeneral',
  vipLevel: 1,
  path: '/report/general/:projectId/:reportId',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/report/general'));
    });
  }
}, {
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/report/sectionSummary'));
    });
  },
  meta: {
    title: '区间概况',
    'pageKey': 's_list'
  },
  name: 'SList',
  vipLevel: 1,
  path: '/report/s_list/:projectId/:reportId',
  children: [{
    meta: {
      title: '区间列表',
      'pageKey': 's_list'
    },
    name: 'SList',
    vipLevel: 1,
    path: '/report/s_list/:projectId/:reportId',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/report/sectionSummary'));
      });
    }
  }]
}, {
  meta: {
    title: 'CPU',
    'pageKey': 'c_summary'
  },
  name: 'CSummary',
  vipLevel: 1,
  path: '/report/c_summary/:projectId/:reportId',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/report/cpuSummary'));
    });
  }
}, // {
//   meta: { title: '运行信息' },
//   name: 'ReportRunInfo',
//   vipLevel: 1,
//   path: '/report/runInfo/:projectId/:reportId',
//   component: () => import('@/views/report/runInfo')
// },
{
  meta: {
    title: '内存',
    'pageKey': 'm_summary'
  },
  name: 'MSummary',
  vipLevel: 1,
  path: '/report/m_summary/:projectId/:reportId',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
    });
  }
}, {
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
    });
  },
  meta: {
    title: '重点模块'
  },
  path: '/report/m_render/:projectId/:reportId',
  vipLevel: 1,
  name: 'MRender',
  children: [{
    meta: {
      title: '渲染模块',
      'pageKey': 'm_render'
    },
    name: 'MRender',
    vipLevel: 1,
    path: '/report/m_render/:projectId/:reportId',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
      });
    }
  }, {
    meta: {
      title: '物理模块',
      'pageKey': 'm_physics'
    },
    name: 'MPhysics',
    vipLevel: 1,
    path: '/report/m_physics/:projectId/:reportId',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
      });
    }
  }, {
    meta: {
      title: '动画模块',
      'pageKey': 'm_animation'
    },
    name: 'MAnimation',
    vipLevel: 1,
    path: '/report/m_animation/:projectId/:reportId',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
      });
    }
  }, {
    meta: {
      title: '加载模块',
      'pageKey': 'm_load'
    },
    name: 'MLoad',
    vipLevel: 1,
    path: '/report/m_load/:projectId/:reportId',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
      });
    }
  }, {
    meta: {
      title: '粒子系统',
      'pageKey': 'm_particle'
    },
    name: 'MParticle',
    vipLevel: 1,
    path: '/report/m_particle/:projectId/:reportId',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
      });
    }
  }, {
    meta: {
      title: 'shader',
      'pageKey': 'm_shader'
    },
    name: 'MShader',
    vipLevel: 1,
    path: '/report/m_shader/:projectId/:reportId',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
      });
    }
  }, {
    meta: {
      title: 'ui模块',
      'pageKey': 'm_ui'
    },
    name: 'MUi',
    vipLevel: 1,
    path: '/report/m_ui/:projectId/:reportId',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
      });
    }
  }]
}, {
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
    });
  },
  meta: {
    title: '资源'
  },
  path: '/report/r_texture/:projectId/:reportId',
  vipLevel: 1,
  name: 'RTexture',
  children: [{
    meta: {
      title: '纹理资源',
      'pageKey': 'r_texture'
    },
    name: 'RTexture',
    vipLevel: 1,
    path: '/report/r_texture/:projectId/:reportId',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
      });
    }
  }, {
    meta: {
      title: '几何数据',
      'pageKey': 'r_geometry'
    },
    name: 'RGeometry',
    vipLevel: 1,
    path: '/report/r_geometry/:projectId/:reportId',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
      });
    }
  }]
}, {
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
    });
  },
  meta: {
    title: '图形'
  },
  path: '/report/g_summary/:projectId/:reportId',
  vipLevel: 1,
  name: 'GSummary',
  children: [{
    meta: {
      title: '概况',
      'pageKey': 'g_summary'
    },
    name: 'GSummary',
    vipLevel: 1,
    path: '/report/g_summary/:projectId/:reportId',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
      });
    }
  }, {
    meta: {
      title: '合批',
      'pageKey': 'g_batch'
    },
    name: 'GBatch',
    vipLevel: 1,
    disabled: true,
    path: '/report/g_batch/:projectId/:reportId',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
      });
    }
  }, {
    meta: {
      title: 'Overdraw',
      'pageKey': 'g_overdraw'
    },
    name: 'GOverdraw',
    vipLevel: 1,
    disabled: true,
    path: '/report/g_overdraw/:projectId/:reportId',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
      });
    }
  }]
}, {
  meta: {
    title: '自动化测试',
    'pageKey': 'autoTest'
  },
  name: 'ReportAutoTest',
  vipLevel: 3,
  path: '/report/autoTest/:projectId/:reportId',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/report/autoTest'));
    });
  }
}, {
  meta: {
    title: '自定义数据',
    'pageKey': 'cus_period'
  },
  name: 'CusPeriod',
  vipLevel: 1,
  path: '/report/cus_period/:projectId/:reportId',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
    });
  },
  children: [{
    meta: {
      title: '时间间隔数据',
      'pageKey': 'cus_period'
    },
    name: 'CusPeriod',
    vipLevel: 1,
    path: '/report/cus_period/:projectId/:reportId',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
      });
    }
  }, {
    meta: {
      title: '数值数据',
      'pageKey': 'cus_count'
    },
    name: 'CusCount',
    vipLevel: 1,
    path: '/report/cus_count/:projectId/:reportId',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
      });
    }
  }]
}, {
  meta: {
    title: '蓝图',
    'pageKey': 'bule_print'
  },
  name: 'BulePrint',
  vipLevel: 1,
  disabled: true,
  path: '/report/bule_print/:projectId/:reportId',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
    });
  }
}, {
  meta: {
    title: '硬件',
    'pageKey': 'hardware'
  },
  name: 'Hardware',
  vipLevel: 1,
  disabled: true,
  path: '/report/bule_print/:projectId/:reportId',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/report/template'));
    });
  }
} // {
//   component: Layout,
//   meta: { title: '测试多级导航' },
//   path: '/report/template0/:projectId/:reportId',
//   vipLevel: 1,
//   name: 'ReportTemplate0',
//   children: [
//     {
//       meta: { title: '测试模版0', 'key': 'template0' },
//       name: 'ReportTemplate0',
//       vipLevel: 1,
//       path: '/report/template0/:projectId/:reportId',
//       component: () => import('@/views/report/template')
//     },
//     {
//       meta: { title: '测试模版1', 'key': 'template1' },
//       name: 'ReportTemplate1',
//       vipLevel: 1,
//       path: '/report/template1/:projectId/:reportId',
//       component: () => import('@/views/report/template')
//     }
//   ]
// }
]; // 不在导航的路由

exports.reportNavList = reportNavList;
var excludeReportNavList = [{
  meta: {
    title: '报告对比'
  },
  name: 'ReportCompare',
  vipLevel: 1,
  path: '/report/compare/:projectId/:reportId',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/report/compare'));
    });
  }
}];
exports.excludeReportNavList = excludeReportNavList;
var scoreLevel = [{
  'score': [0, 59],
  'name': 'D'
}, {
  'score': [60, 69],
  'name': 'C'
}, {
  'score': [70, 79],
  'name': 'B'
}, {
  'score': [80, 89],
  'name': 'A'
}, {
  'score': [90, 94],
  'name': 'S'
}, {
  'score': [95, 100],
  'name': 'SSS'
}];
exports.scoreLevel = scoreLevel;